import React from "react";
import './Footer.css'
import { Container } from "react-bootstrap";


const Footer: React.FC = () => {
    const year = new Date().getFullYear();

    return (
        <footer className={`app-footer`}>
            <Container className="py-3">
                <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2">
                    <small style={{'color': "#a0a09f"}}>
                        © {year} <span>vi2vi Retail Solution GmbH</span>
                    </small>

                    <div className="d-flex gap-3">
                        <a className="footer-link" href="https://vi2vi.com/impressum">
                            Impressum
                        </a>
                        <a className="footer-link" href="https://vi2vi.com/datenschutzerklaerung/">
                            Datenschutz
                        </a>
                    </div>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;